import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { finalize, catchError } from "rxjs/operators";
import { InterceptorService } from "./interceptor.service";
import { SmarttableService } from "./admin/smarttable.service";
import { ToastrService } from "./toastr.service";

declare var Pace: any;

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(
    private readonly interceptorService: InterceptorService,
    private readonly smarttableService: SmarttableService,
    private readonly toastr: ToastrService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if the URL contains 'page' and 'limit' query parameters
    const hasPaginationParams =
      req.urlWithParams.includes("page") && req.urlWithParams.includes("limit"); // validatros?

    this.interceptorService.show();
    if (hasPaginationParams) {
      this.smarttableService.show();
    }

    if (typeof Pace !== "undefined") {
      Pace.restart();
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = "An unknown error occurred!";
        if (error.error instanceof ErrorEvent) {
          // Client-side error
          errorMessage = error.error.message;
        } else {
          // Server-side error
          errorMessage =
            error.error?.message ||
            error.message ||
            `Error Code: ${error.status}`; // Handle specific status codes

          if (error.status === 401) {
            // Let AuthInterceptor handle redirect, but maybe show toast
            // errorMessage = 'Unauthorized access.';
          }
        } // Don't show toast for 401 if we want to silence it during redirect, otherwise show it

        if (error.status !== 401) {
          this.toastr.danger(errorMessage, "Error");
        }

        return throwError(() => error);
      }),
      finalize(() => {
        // Hide both loading indicators
        this.interceptorService.hide();
        if (hasPaginationParams) {
          this.smarttableService.hide();
        }
        if (typeof Pace !== "undefined") {
          Pace.stop();
        }
      })
    );
  }
}
